export default __webpack_public_path__ + "static/media/name.5e900c75.png";